if (!customElements.get('sticky-atc')) {
  class StickyATC extends HTMLElement {
    constructor() {
      super();

      this.selects = [...this.querySelectorAll('select-menu')]
      this.button = this.querySelector('button[name="add"]');
      this.footer = document.querySelector('footer.footer')
      this.debouncedResize = debounce(() => this.updateHeight(), 250);
    }

    connectedCallback() {
      this.coreATC = document.querySelector('.product-form__submit--primary');

      this.createObservers();
    }

    disconnectedCallback() {
      this.destroyObservers();
    }

    createObservers() {
      this.intersectionObserver = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            this.hide();
          } else {
            this.show();
          }
        },
        {
          rootMargin: `${this.coreATC.offsetHeight}px 0px 0px 0px`,
          threshold: 1,
        }
      );

      this.intersectionObserver.observe(this.coreATC);

      this.resizeObserver = new ResizeObserver(this.debouncedResize.bind(this));
      this.resizeObserver.observe(this);

      this.observeATC()
    }

    observeATC() {
      const initialCoreButtonClasses = [...this.coreATC.classList];
      let previousCoreButtonClasses = [...initialCoreButtonClasses];
      this.atcObserver = new MutationObserver((mutations, observer) => {
        for (const mutation of mutations) {
          switch (mutation.type) {
            case 'childList':
              this.button.innerHTML = this.coreATC.innerHTML
              break;
            case 'attributes':
              // Set attribute target
              let attributeTarget = this.button;
              if (mutation.target !== this.coreATC) {
                // Map attribute target to sticky ATC button equivalent
                const targetClass = [...mutation.target.classList][0];
                attributeTarget = this.button.querySelector(`.${targetClass}`);
              }

              if (!attributeTarget) continue

              if (mutation.attributeName === 'disabled') {
                attributeTarget.toggleAttribute('disabled', mutation.target.hasAttribute('disabled'))
              } else if (mutation.attributeName === 'class' && attributeTarget === this.button) {
                // If button classes update, apply only changes from initial / previous states
                const addedClasses = [...this.coreATC.classList].filter(className => !initialCoreButtonClasses.includes(className));
                if (addedClasses.length > 0) this.button.classList.add(...addedClasses);

                const removedClasses = [...previousCoreButtonClasses].filter(className => ![...this.coreATC.classList].includes(className));
                if (removedClasses.length > 0) this.button.classList.remove(...removedClasses);

                previousCoreButtonClasses = [...this.coreATC.classList];
              } else if (mutation.target.hasAttribute(mutation.attributeName)) {
                attributeTarget.setAttribute(mutation.attributeName, mutation.target.getAttribute(mutation.attributeName))
              } else {
                attributeTarget.removeAttribute(mutation.attributeName)
              }
              break;
          }
        }
      })

      this.atcObserver.observe(this.coreATC, { subtree: true, childList: true, attributes: true });
    }

    destroyObservers() {
      this.intersectionObserver?.disconnect();
      this.resizeObserver?.disconnect();
      // this.coreMutationObserver?.disconnect();
      this.atcObserver?.disconnect();
      this.updateHeight(true);

      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
        this.variantChangeUnsubscriber = null;
      }
    }

    // pad(reset = false) {
    //   this.footer.style.paddingBottom = reset ? '' : `${this.offsetHeight}px`;
    // }

    updateHeight(reset = false) {
      document.documentElement.style.setProperty('--sticky-atc-height', reset ? '' : `${this.offsetHeight}px`);
    }

    hide() {
      document.body.classList.remove('has-sticky-atc');

      for (const select of this.selects) {
        select.close()
      }

      this.classList.add('is-hidden')
    }

    show() {
      document.body.classList.add('has-sticky-atc');
      this.classList.remove('is-hidden')
    }
  }

  customElements.define('sticky-atc', StickyATC);
}
